export default __webpack_public_path__ + "static/poster-5c973a7e6ef7a2d23fb18fccb6a73741.png";